import { render } from "./PoliticasView.vue?vue&type=template&id=11b3e5b1&scoped=true"
import script from "./PoliticasView.vue?vue&type=script&lang=js"
export * from "./PoliticasView.vue?vue&type=script&lang=js"

import "./PoliticasView.vue?vue&type=style&index=0&id=11b3e5b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b3e5b1"]])

export default __exports__